export const GET_ALL_SERVICE_PRODUCT = "GET_ALL_SERVICE_PRODUCT";
export const GET_ALL_SERVICE_PRODUCT_SUCCESS = "GET_ALL_SERVICE_PRODUCT_SUCCESS";
export const GET_ALL_SERVICE_PRODUCT_FAILED = "GET_ALL_SERVICE_PRODUCT_FAILED";

export const GET_BILLING_INFO = "GET_BILLING_INFO";
export const GET_BILLING_INFO_SUCCESS = "GET_BILLING_INFO_SUCCESS";
export const GET_BILLING_INFO_FAILED = "GET_BILLING_INFO_FAILED";

export const GET_SERVICE_DATA = "GET_SERVICE_DATA";
export const GET_SERVICE_DATA_SUCCESS = "GET_SERVICE_DATA_SUCCESS";
export const GET_SERVICE_DATA_FAILED = "GET_SERVICE_DATA_FAILED";